import script from "./Registered.vue?vue&type=script&lang=ts&setup=true"
export * from "./Registered.vue?vue&type=script&lang=ts&setup=true"

import "./Registered.vue?vue&type=style&index=0&id=0673d6d4&scoped=true&lang=less"
import "./Registered.vue?vue&type=style&index=1&id=0673d6d4&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0673d6d4"]])

export default __exports__